import { FC } from 'react';

import PropTypes from 'prop-types';

import { RequisitesItemProps, RequisitesProps } from './types';

import styles from './Requisites.module.scss';

const Requisites: FC<RequisitesProps> & { Item: FC<RequisitesItemProps> } = ({ children }) => {
  return <div className={styles.requisites}>{children}</div>;
};

Requisites.Item = ({ title, description }) => (
  <div className={styles.item}>
    <div className={styles.title}>{title}</div>{' '}
    <div className={styles.description}>{description}</div>
  </div>
);

Requisites.propTypes = {
  children: PropTypes.node.isRequired,
};

Requisites.Item.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

Requisites.Item.displayName = 'RequisitesItem';

export default Requisites;
